"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _useToggler2 = _interopRequireDefault(require("../../hooks/useToggler"));

var _useTrigger2 = _interopRequireDefault(require("../../hooks/useTrigger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * The Drawer component provides a way to display information in a panel anchored to the side of the screen.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/reactjs/react-modal">ReactModal</a>.
 */
var Drawer = function Drawer(props) {
  var controlledIsOpen = props.isDrawerOpen,
      initialTrigger = props.trigger,
      drawerScopeCSS = props.drawerScopeCSS,
      drawerTitle = props.drawerTitle,
      side = props.side,
      onOpen = props.onOpen,
      onClose = props.onClose,
      disabled = props.disabled,
      children = props.children,
      className = props.className,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex;

  var _useToggler = (0, _useToggler2.default)(false),
      isOpen = _useToggler.isOpen,
      setOpen = _useToggler.setOpen,
      setClose = _useToggler.setClose;

  var _useTrigger = (0, _useTrigger2.default)(initialTrigger, {
    // ...props,
    tabIndex: tabIndex,
    onClick: function onClick(event) {
      return disabled ? {} : handleOpenDrawer(initialTrigger, event);
    },
    className: (0, _clsx.default)(props.className, 'uk-drawer__trigger')
  }),
      trigger = _useTrigger.trigger;

  _react.default.useEffect(function () {
    if (controlledIsOpen) {
      setOpen();
    } else {
      setClose();
    }
  }, [controlledIsOpen, setClose, setOpen]);

  var handleOpenDrawer = function handleOpenDrawer(trigger, event) {
    if (trigger.props && trigger.props.disabled || disabled) {
      return null;
    }

    setOpen();

    if (trigger.props && trigger.props.onClick) {
      trigger.props.onClick(event);
    }

    if (typeof onOpen === 'function') {
      onOpen({
        drawerShow: true
      });
    }
  };

  var handleCloseDrawer = function handleCloseDrawer() {
    setClose();

    if (typeof onClose === 'function') {
      onClose({
        drawerShow: false
      });
    }
  };

  var baseClass = (0, _clsx.default)('uk-drawer__inner', side, className);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, trigger, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isOpen,
    ariaHideApp: false,
    portalClassName: (0, _clsx.default)('uk-drawer', side, drawerScopeCSS),
    className: {
      base: baseClass,
      afterOpen: 'uk-drawer__inner--after-open',
      beforeClose: 'uk-drawer__inner--before-close'
    },
    overlayClassName: {
      base: 'uk-drawer__overlay',
      afterOpen: 'uk-drawer__overlay--after-open',
      beforeClose: 'uk-drawer__overlay--before-close'
    },
    bodyOpenClassName: "uk-drawer--is-open",
    htmlOpenClassName: "uk-drawer--is-open",
    onRequestClose: handleCloseDrawer,
    closeTimeoutMS: 720,
    aria: {
      labelledby: 'dialog-label',
      describedby: 'dialog-desc'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-drawer__wrapper"
  }, drawerTitle && /*#__PURE__*/_react.default.createElement("h5", {
    className: "uk-drawer__title",
    id: "dialog-label"
  }, drawerTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-drawer__body",
    id: "dialog-desc"
  }, typeof children === 'function' ? children({
    isOpen: isOpen,
    setClose: setClose,
    handleCloseDrawer: handleCloseDrawer
  }) : children))));
};

Drawer.propTypes = {
  /**
   * Show or hide the Drawer (controlled)
   */
  isDrawerOpen: _propTypes.default.bool,

  /**
   * Trigger of the Drawer
   * If the trigger isn't a React element, it will be wrapped within a <span/>
   */
  trigger: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,

  /**
   * As the Drawer is displayed in a ReactPortal, it may need to have its CSS scoped
   */
  drawerScopeCSS: _propTypes.default.string,

  /**
   * Title of the Drawer
   */
  drawerTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * Side from which the Drawer will be anchored
   */
  side: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Callback function onOpen
   */
  onOpen: _propTypes.default.func,

  /**
   * Callback function onClose
   */
  onClose: _propTypes.default.func
};
Drawer.defaultProps = {
  isDrawerOpen: false,
  side: 'right'
};
var _default = Drawer;
exports.default = _default;